<div class="task-hover-container" [ngStyle]="taskHoverContainerStyle" *ngIf="taskHoverModel">
  <div class="task-hover-container-arrow-bottom" [ngStyle]="taskHoverContrainerArrowButton"></div>
  <div class="task-hover-container-arrow-bottom-border" [ngStyle]="taskHoverContrainerArrowButton"></div>
  <div class="task-hover-container-content">
    <div class="task-title">{{taskHoverModel.title}}</div>
    <div class="task-description" [innerHTML]="htmlFormattedDescription | safeHtml"></div>
  </div>
</div>
